<template>
    <div class="contract">
        <el-table
                :data="list"
                style="width: 1200px;margin: 0 auto;margin-top: 50px">
            <el-table-column
                    prop="user_id"
                    header-align="center"
                    align="center"
                    :show-overflow-tooltip="true"
                    label="用户"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="token_name"
                    header-align="center"
                    align="center"
                    :show-overflow-tooltip="true"
                    label="存证名称"
                    width="180">
                <template slot-scope="scope">
                    <span>{{scope.row.token_name.replace(/中钞/g, "融权")}}</span>
                </template>
            </el-table-column>
            <!--                    <el-table-column-->
            <!--                            prop="channelname"-->
            <!--                            header-align="center"-->
            <!--                            align="center"-->
            <!--                            label="通道号"-->
            <!--                            width="180">-->
            <!--                    </el-table-column>-->
            <el-table-column
                    prop="chain_tx_id"
                    header-align="center"
                    align="center"
                    :show-overflow-tooltip="true"
                    label="交易哈希">
<!--                <template slot-scope="scope">-->
<!--                    <el-button type="text" @click="getTransaction(scope.row.chain_tx_id,scope.row.type)">{{scope.row.chain_tx_id}}</el-button>-->
<!--                </template>-->
            </el-table-column>
<!--            <el-table-column-->
<!--                    prop="type"-->
<!--                    header-align="center"-->
<!--                    align="center"-->
<!--                    label="类型">-->
<!--                <template slot-scope="scope">-->
<!--                    <span v-if="scope.row.type == '1'">铸造</span>-->
<!--                    <span v-if="scope.row.type == '2'">交易</span>-->
<!--                </template>-->
<!--            </el-table-column>-->
            <el-table-column
                    header-align="center"
                    align="center"
                    prop="contract"
                    :show-overflow-tooltip="true"
                    label="合约名称">
<!--                <template slot-scope="scope">-->
<!--                    <span>TDAPFXE7EPL4W6EMIRWV2FDLQ4XR4TZF</span>-->
<!--                </template>-->
            </el-table-column>
            <el-table-column
                    prop="created_time"
                    header-align="center"
                    align="center"
                    label="时间">
                <template slot-scope="scope">
                    <span>{{scope.row.created_time | dateFormate}}</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                @size-change="sizeChangeHandle"
                @current-change="currentChangeHandle"
                :current-page="page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="limit"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
    </div>
</template>

<script>
    export default {
        name: "contract-address",
        data(){
            return{
                list:[],
                total:0,
                limit:10,
                page:1
            }
        },
        created() {
            this.getContract()
        },
        methods:{
            getContract(){
                this.$http.get(this.$http.baseURL2+'/nfe/sync/contractinfouserlist',{
                    params:{
                        contract:this.$route.query.id,
                        pageIndex:this.page,
                        pageSize:this.limit
                    },
                }).then((res)=>{
                    this.list = res.data.data.list
                    this.total = res.data.data.count
                })
            },
            sizeChangeHandle (val) {
                this.limit = val
                this.page = 1
                this.getContract()
            },
            currentChangeHandle (val) {
                this.page = val
                this.getContract()
            },
        }
    }
</script>

<style scoped lang="scss">
</style>